import { Box, Button, Typography,useMediaQuery } from "@mui/material";
import React ,{useState,useEffect,useRef}from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
const apiUrl = process.env.REACT_APP_API_REST_URL;



const Agreement = (props) => {
  const {isdata} = props
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;
  console.log("userid", userId);
const iframeRef=useRef(null);


  
  const handleiagree = async () => {
    try {
      console.log(isdata,'isdata')
      const response = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/updateUser`, {
        // ...isdata,
        userId: userId,
        consent : true,
        agreement : "Electronically Signed"

      });
      // await axios.get(`${url}commonEngine/professions`);

      console.log("Response: Agreed", response);
      
    } catch (error) {
      console.error("Error:", error.message);

    }
    // try {
    //   // Example update request
    //   const updateResponse = await axios.put(`${apiUrl}/CCE/api/v1/userEngine/updateUser`, {
    //     userId: userId,
    //     consent: true,
    //   });

    //   console.log("Update Response:", updateResponse.data);

    //   // Navigate to the "Thank You" page on successful agreement
    //   navigate("/thankyou", { state: { userId } });
    // } catch (error) {
    //   console.error("Error updating user:", error.message);
    //   // Handle the error appropriately
    // }

    if(isdata?.isFromIns){
      navigate("/insurance-signin", { state: { userId } });
  }else{
    navigate("/thankyou", { state: { userId } });
  }

  };

  const handleCancel = () => {
    navigate("/");
  };




  return (
    <>{isSmallScreen ?
    (<span> 
      <Box sx={styles.formboxresponsive}>
      <Box
        onClick={handleCancel}
        sx={{
          textAlign: "right",
          cursor: "pointer",
          color: "#666666",minHeight: "20px"
        }}
      >
         {!isdata?.isFromIns && <CloseIcon />}
      </Box>
      <h2 style={{ marginTop: "-20px" }}>Agreement</h2>

      
     <Box
  sx={{
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    // height: "60vh", // Full viewport height for vertical centering
  }}
>
  <div style={{ height: "350px", width: "400px" }} 
   >
    <iframe 
      src="https://www.investek.in/termsandconditions"
      width="100%"  // Full width of the parent div
      height="100%" // Full height of the parent div
      style={{ border: "none" }} 
      title="Terms and Conditions"
    />
  </div>
</Box>
      {/* -------------------------------------------------------------------------------- */}
      <Button sx={styles.btn} onClick={handleiagree}>
        I Agree
      </Button>
    </Box></span>):(<span> 
      <Box sx={styles.formbox}>
      <Box
        onClick={handleCancel}
        sx={{
          textAlign: "right",
          cursor: "pointer",
          color: "#666666",  minHeight: "20px"
        }}
      >
        {!isdata?.isFromIns && <CloseIcon />}
      </Box>
      <h2 style={{ marginTop: "-20px" }}>Agreement</h2>

     
     <Box
  sx={{
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    // height: "60vh", // Full viewport height for vertical centering
  }}
>
  <div style={{ height: "350px", width: "450px" }} >
    <iframe 
      src="https://www.investek.in/termsandconditions"
      width="100%"  // Full width of the parent div
      height="100%" // Full height of the parent div
      style={{ border: "none" }} 
      title="Terms and Conditions"
    />
  </div>
</Box>

      {/* -------------------------------------------------------------------------------- */}
      <Button sx={styles.btn} onClick={handleiagree}>
        I Agree
      </Button>
    </Box></span>)}</>
   
  );
};

export default Agreement;

const styles = {
  formbox: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "490px",
    // minHeigh:"calc(100vh - 250px)",
    width: "480px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "490px",
    // minHeigh:"calc(100vh - 250px)",
    width: "320px",
  },
  textfield: {
    width: "400px",
  },
  btn: {
    width: "150px",
    marginTop: "3em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  // scrollbox: {
  //   maxHeight: "300px", // Set the maximum height for the scrollable content
  //   overflowY: "auto",
  // },

  // scrollbox: {
  //   Height: "600px",
  //   overflowY: "auto",
  //   scrollbarWidth: "thin",
  //   "&::-webkit-scrollbar": {
  //     width: "4px",
  //   },
  //   "&::-webkit-scrollbar-thumb": {
  //     backgroundColor: "#888",
  //     borderRadius: "4px",
  //   },
  //   "&::-webkit-scrollbar-track": {
  //     backgroundColor: "#f1f1f1",
  //   },
  // },

  agreement_title: {
    margin: "10px 0px",
    fontSize: "16px",
    fontWeight: 600,
  },
};


 {/* <Box sx={styles.scrollbox}>
        <h2 style={{ margin: "5px 24px", textAlign: "left", fontSize: "18px" }}>
          &nbsp;&nbsp;&nbsp;TERMS AND CONDITIONS
        </h2>
        <h2 style={{ margin: "5px 10px", textAlign: "left", fontSize: "18px" }}>
          &nbsp;&nbsp;&nbsp;1 Definition and Interpretation
        </h2>
        <h2 style={{ margin: "5px 10px", textAlign: "left", fontSize: "18px" }}>
          1.1 Definition
        </h2>

        <Box
          sx={{ display: "flex", flexDirection: "column", textAlign: "left" }}
        >
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.1</span>
            <span>
              “Applicable Law” includes all applicable statutes, enactments,
              acts of legislature or parliament, laws, ordinances, rules, bye
              laws, regulations, notifications, guidelines, policies, protocols,
              treaties, codes, directions, directives and orders of any
              Governmental Authority.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.2</span>
            <span>
              “Confidential Information” shall mean and include any information
              disclosed by the Disclosing Party to the Receiving Party directly
              or indirectly, whether in writing, orally or otherwise such as,
              but not limited to information, data and other material (both
              written and oral) which may be proprietary and/or confidential to
              the Disclosing Party including, without limitation, in relation to
              employee lists, list of products, methods and operating
              techniques, procedures and methods, sales, advertising and
              marketing methods, development and service methods, business
              techniques, business data, terms and conditions of contracts and
              transactions and/or any information directly or incidentally
              connected to any Intellectual Property Rights irrespective that
              the information or materials should be treated as confidential,
              whether or not the specific designation “confidential” or any
              similar designation is used.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.3</span>
            <span>
              “Indemnifying Party” shall have the meaning as given in clause 7.1
              of this agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.4</span>
            <span>
              “Indemnified Party” shall have the meaning as given in clause 7.1
              of this agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.5</span>
            <span>
              “Prospective Client” shall refer to those clients who the Referral
              Partner will procure for the business interest of First Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.6</span>
            <span>
              “Referred Client” shall have the meaning as given in Clause 3.1 of
              this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.7</span>
            <span>“SEBI” shall stand for </span>&nbsp;
            <strong>Securities and Exchange Board of India.</strong>
          </Typography>

          <span></span>

          <Typography variant="h6" sx={styles.agreement_title}>
            1.2 Interpretation
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.1</span>
            <span>words of any gender include each other gender;</span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.2</span>
            <span>
              words using the singular or plural number also include the plural
              or singular number, respectively;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.3</span>
            <span>
              the terms “hereof”, “herein”, “hereby” and derivative or similar
              words refer to this entire Agreement and not to any particular
              clause, article or section of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.4</span>
            <span>
              headings and captions are used for convenience only and shall not
              affect the interpretation of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.5</span>
            <span>
              references to Recitals, Clauses, sub-clauses, Sections,
              sub-sections, Schedules, Annexures and Appendices shall be deemed
              to be a reference to the recitals, clauses, sub-clauses, Sections,
              sub-sections, schedules and appendices of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.6</span>
            <span>
              any reference to any statute or statutory provision shall include:
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 18px" }}>(i)</span>
            <span>
              all subordinate legislation made from time to time under that
              provision (whether or not amended, modified, re-enacted or
              consolidated);
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 15px" }}>(ii)</span>
            <span>
              such statute or provision as may be amended, modified, re-enacted
              or consolidated;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.7</span>
            <span>
              the word “including” herein shall always mean “including, without
              limitation”;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.8</span>
            <span>
              the Schedule, Annexures and Exhibits to this Agreement form an
              integral part of this Agreement;
            </span>
          </Typography>

          <Typography variant="h6" sx={styles.agreement_title}>
            2. Referral Relationship
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 6px" }}>2.1</span>
            <span>
              Referrals. Referral Partner may on a non- exclusive refer
              potential clients or customers to First Party who express an
              interest in First Party Services in any form and manner as
              prescribed by First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>2.2</span>
            <span>
              Acceptance of Referrals. First Party reserves shall have the sole
              discretion to accept or decline any referral made under this
              Agreement. First Party shall not be obligated to enter into any
              contract or agreement with a Referred Customer.
            </span>
          </Typography>

          <Typography variant="h6" sx={styles.agreement_title}>
            3. Representation and Warranties by the Referral Partner
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 10px" }}>3.1</span>
            <span>
              The Referral Partner shall ensure that the Referred Client is
              known to him/her prior to making the reference to the First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.2</span>
            <span>
              The Referral Partner shall itself perform its obligation under
              this Arrangement and shall not assign, transfer or sub-contract
              any of its rights and obligation under this Arrangement except
              with prior written permission of First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.3</span>
            <span>
              The Referral Partner agrees not make any representations or
              statement concerning schemes/ products of the First Party or the
              business of the First Party to the Referred Client on behalf of
              the First Party. However, the Referral Partner may use the
              information issued by the First Party to help procure the Referred
              Client.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.4</span>
            <span>
              In case the prospective client has any queries or requires any
              further information regarding the First Party, then the Referral
              Partner shall immediately revert these queries to the First Party
              rather than taking it upon himself/herself to answer these
              queries.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.5</span>
            <span>
              Under no circumstances the Referral partner shall represent
              himself/ herself as the agent or employee of the First Party nor
              display or use the Logo or name of the First Party to procure
              prospective clients.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.6</span>
            <span>
              Referral Partner while providing Referred Clients to the First
              Party shall not violate any Provisions, Rules, Regulations and
              Laws of the Country.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            4. Compensation
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.1</span>
            <span>
              Payment. If a Referred Client engages the services of the other
              party, the First Party shall pay a referral fee to the party
              making the Referral Partner in accordance with the fee structure
              outlined in Exhibit A attached here to.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.2</span>
            <span>
              Payment Terms. Payment of referral fees shall be made for 3 years
              and the payouts shall be made in every subsequent Calendar Quarter
              plus 1 (One) month as per the manual that will be shared after
              acceptance of the terms and conditions.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.3</span>
            <span>
              The rates of referral fees are subject to revision by First Party
              from time to time and the Referral Partner shall be bound by the
              said revisions.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.4</span>
            <span>
              First Party may at its sole discretion decide not to pay such
              referral fee to the Referral Partner with respect to any
              client(s).
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.5</span>
            <span>
              The commission/fees payable to the Referral Partner will be
              governed by the norms specified by SEBI/ relevant regulator, if
              any, from time to time.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.6</span>
            <span>
              In the event any discrepancies / excess payment to Referral
              Partner is given on account of an error, then the Referral Partner
              shall reimburse such excessive amounts to First Party, failing
              which First Party shall be entitled to adjust the same from the
              referral fees to be paid by First Party to the Referral Partner in
              the subsequent fees to be paid.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.7</span>
            <span>
              All payments to be made out to Referral Partner under the terms of
              this Agreement shall be subject to the deduction of all applicable
              Taxes.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            5. Term and Termination
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.1</span>
            <span>
              Term. This Agreement shall commence on the Effective Date and
              shall continue in full force and effect until terminated by either
              party with written notice to the other party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.2</span>
            <span>
              Termination for Convenience. Either party may terminate this
              Agreement for convenience upon [Specify Notice Period, e.g., 30
              days] written notice to the other party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.3</span>
            <span>
              Termination for Cause. Either party may terminate this Agreement
              immediately if the other party breaches any material term or
              condition of this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.4</span>
            <span>
              In case of termination by First Party, any outstanding payment
              shall be forfeited by the Referral Partner.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.5</span>
            <span>
              In the event of a mutual termination of the agreement this
              Agreement shall continue till all outstanding payments of the
              Referral Partner are not cleared, however all obligations of the
              Referral Partner shall stand terminated on the day of termination
              of Agreement.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            6. Confidentiality
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 6px" }}>6.1</span>
            <span>
              The Receiving Party shall use the Confidential Information
              disclosed by the Disclosing Party solely for the purpose of its
              respective obligations under the Agreement. Except with the prior
              written consent of the Disclosing Party, the Receiving Party shall
              not disclose any Confidential Information of the Disclosing Party
              other than on a need-to-know basis to its own directors,
              employees, attorneys, accountants etc. The Confidential
              Information shall at all times remain the Disclosing Party’s
              property and shall not be copied or reproduced by the Receiving
              Party without prior written consent of the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.2</span>
            <span>
              The Receiving Party agrees and undertakes not to disclose either
              directly or indirectly, to any person(s) or entity, any
              Confidential Information of the Disclosing Party which is
              commercially sensitive or disclosure of which would adversely
              affect the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.3</span>
            <span>
              The Provision under this clause shall survive the termination of
              this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.4</span>
            <span>
              The obligation of confidentiality contained in this clause shall
              not apply in the following circumstances:
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 12px" }}>(i)</span>
            <span>
              that which is or becomes generally available in the public domain
              other than by the Receiving Party’s breach of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 10px" }}>(ii)</span>
            <span>
              that which was previously known, as established by records of the
              Receiving Party prior to receipt from the Disclosing Party and in
              possession of the Receiving Party prior to the Execution Date of
              this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(iii)</span>
            <span>
              that which was lawfully obtained by the Receiving Party from a
              third party;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(iv)</span>
            <span>
              that which was developed independently by the Receiving Party
              without reference to the Confidential Information provided by the
              Disclosing Party;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 8px" }}>(v)</span>
            <span>
              that which is disclosed or released in the public domain by the
              Receiving Party with the prior written approval of the Disclosing
              Party; or
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(vi)</span>
            <span>
              that which is required under Applicable Law or by any court or
              Governmental Authority to be disclosed, in which case the
              Receiving Party shall provide prompt notice of such request or
              requirement to the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            7. Indemnification
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>7.1</span>
            <span></span> First Party hereby agrees, acknowledges and confirms
            that it has agreed to enter into this Agreement in reliance on the
            representations, warranties, undertakings and covenants made by the
            Referral Partner. The Referral Partner (“Indemnifying Paty”) hereby
            agrees to keep indemnified First Party, including its affiliates and
            their respective directors, officers, employees, agents and
            representatives (the indemnified party and each such Person being an
            “Indemnified Party”) from and against, any and all losses, claims,
            costs and expenses, penalties, Taxes, damages and liabilities,
            including Third Party Claims for damages, incurred on account of:
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 10px" }}>(i)</span>
            breach or non-performance by Referral Partner of any of its
            undertakings, warranties, covenants, declarations or obligations
            under this Agreement;
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            8. Dispute Resolution
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>8.1</span>
            <span>
              <Typography variant="body2">
                All or any disputes arising out of or in relation to the terms
                of this Agreement including the interpretation and validity of
                the terms thereof and the respective rights and obligations of
                the Parties shall be settled amicably by mutual discussions to
                the extent possible by prompt and good faith negotiation between
                Parties.
              </Typography>
              <Typography variant="body2" mt={1}>
                In the event Parties fail to reach an amicable settlement as per
                clause 8.1 above, the dispute shall be referred to a sole
                arbitrator mutually appointed by both Parties for adjudication
                as per the Arbitration and Conciliation Act, 1996 or any
                statutory amendments/modifications thereto for the time being in
                force. The award of the arbitrator shall be final and binding
                upon the Parties. The arbitration shall be held at Gurgoan and
                proceedings shall be conducted in English. The Parties shall
                bear their own expenses for the arbitration. All administrative
                costs of the arbitration, including fees of the mutually
                appointed arbitrator shall be equally borne by the Parties.
              </Typography>
              <Typography variant="body2" mt={1}>
                This Agreement shall be governed by and interpreted in
                accordance with laws of India and Parties hereto submit to the
                exclusive jurisdiction to the courts at New Delhi.
              </Typography>
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            9. Miscellaneous
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.1</span>
            <span>
              Entire Agreement. This Agreement constitutes the entire agreement
              between the parties and supersedes all prior oral or written
              agreements, understandings, or representations.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.2</span>
            <span>
              Governing Law. This Agreement shall be governed by and construed
              in accordance with the laws of India.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.3</span>
            <span>
              Amendments. Any amendments to this Agreement must be made in
              writing.
            </span>
          </Typography>
        </Box>
      </Box> */}

{/* <Box sx={styles.scrollbox}>
        <h2 style={{ margin: "5px 24px", textAlign: "left", fontSize: "18px" }}>
          &nbsp;&nbsp;&nbsp;TERMS AND CONDITIONS
        </h2>
        <h2 style={{ margin: "5px 10px", textAlign: "left", fontSize: "18px" }}>
          &nbsp;&nbsp;&nbsp;1 Definition and Interpretation
        </h2>
        <h2 style={{ margin: "5px 10px", textAlign: "left", fontSize: "18px" }}>
          1.1 Definition
        </h2>

        <Box
          sx={{ display: "flex", flexDirection: "column", textAlign: "left" }}
        >
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.1</span>
            <span>
              “Applicable Law” includes all applicable statutes, enactments,
              acts of legislature or parliament, laws, ordinances, rules, bye
              laws, regulations, notifications, guidelines, policies, protocols,
              treaties, codes, directions, directives and orders of any
              Governmental Authority.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.2</span>
            <span>
              “Confidential Information” shall mean and include any information
              disclosed by the Disclosing Party to the Receiving Party directly
              or indirectly, whether in writing, orally or otherwise such as,
              but not limited to information, data and other material (both
              written and oral) which may be proprietary and/or confidential to
              the Disclosing Party including, without limitation, in relation to
              employee lists, list of products, methods and operating
              techniques, procedures and methods, sales, advertising and
              marketing methods, development and service methods, business
              techniques, business data, terms and conditions of contracts and
              transactions and/or any information directly or incidentally
              connected to any Intellectual Property Rights irrespective that
              the information or materials should be treated as confidential,
              whether or not the specific designation “confidential” or any
              similar designation is used.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.3</span>
            <span>
              “Indemnifying Party” shall have the meaning as given in clause 7.1
              of this agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.4</span>
            <span>
              “Indemnified Party” shall have the meaning as given in clause 7.1
              of this agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.5</span>
            <span>
              “Prospective Client” shall refer to those clients who the Referral
              Partner will procure for the business interest of First Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.6</span>
            <span>
              “Referred Client” shall have the meaning as given in Clause 3.1 of
              this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.1.7</span>
            <span>“SEBI” shall stand for </span>&nbsp;
            <strong>Securities and Exchange Board of India.</strong>
          </Typography>

          <span></span>

          <Typography variant="h6" sx={styles.agreement_title}>
            1.2 Interpretation
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.1</span>
            <span>words of any gender include each other gender;</span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.2</span>
            <span>
              words using the singular or plural number also include the plural
              or singular number, respectively;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.3</span>
            <span>
              the terms “hereof”, “herein”, “hereby” and derivative or similar
              words refer to this entire Agreement and not to any particular
              clause, article or section of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.4</span>
            <span>
              headings and captions are used for convenience only and shall not
              affect the interpretation of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.5</span>
            <span>
              references to Recitals, Clauses, sub-clauses, Sections,
              sub-sections, Schedules, Annexures and Appendices shall be deemed
              to be a reference to the recitals, clauses, sub-clauses, Sections,
              sub-sections, schedules and appendices of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.6</span>
            <span>
              any reference to any statute or statutory provision shall include:
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 18px" }}>(i)</span>
            <span>
              all subordinate legislation made from time to time under that
              provision (whether or not amended, modified, re-enacted or
              consolidated);
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 15px" }}>(ii)</span>
            <span>
              such statute or provision as may be amended, modified, re-enacted
              or consolidated;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.7</span>
            <span>
              the word “including” herein shall always mean “including, without
              limitation”;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ paddingRight: "10px" }}>1.2.8</span>
            <span>
              the Schedule, Annexures and Exhibits to this Agreement form an
              integral part of this Agreement;
            </span>
          </Typography>

          <Typography variant="h6" sx={styles.agreement_title}>
            2. Referral Relationship
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 6px" }}>2.1</span>
            <span>
              Referrals. Referral Partner may on a non- exclusive refer
              potential clients or customers to First Party who express an
              interest in First Party Services in any form and manner as
              prescribed by First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>2.2</span>
            <span>
              Acceptance of Referrals. First Party reserves shall have the sole
              discretion to accept or decline any referral made under this
              Agreement. First Party shall not be obligated to enter into any
              contract or agreement with a Referred Customer.
            </span>
          </Typography>

          <Typography variant="h6" sx={styles.agreement_title}>
            3. Representation and Warranties by the Referral Partner
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 10px" }}>3.1</span>
            <span>
              The Referral Partner shall ensure that the Referred Client is
              known to him/her prior to making the reference to the First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.2</span>
            <span>
              The Referral Partner shall itself perform its obligation under
              this Arrangement and shall not assign, transfer or sub-contract
              any of its rights and obligation under this Arrangement except
              with prior written permission of First Party
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.3</span>
            <span>
              The Referral Partner agrees not make any representations or
              statement concerning schemes/ products of the First Party or the
              business of the First Party to the Referred Client on behalf of
              the First Party. However, the Referral Partner may use the
              information issued by the First Party to help procure the Referred
              Client.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.4</span>
            <span>
              In case the prospective client has any queries or requires any
              further information regarding the First Party, then the Referral
              Partner shall immediately revert these queries to the First Party
              rather than taking it upon himself/herself to answer these
              queries.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.5</span>
            <span>
              Under no circumstances the Referral partner shall represent
              himself/ herself as the agent or employee of the First Party nor
              display or use the Logo or name of the First Party to procure
              prospective clients.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>3.6</span>
            <span>
              Referral Partner while providing Referred Clients to the First
              Party shall not violate any Provisions, Rules, Regulations and
              Laws of the Country.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            4. Compensation
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.1</span>
            <span>
              Payment. If a Referred Client engages the services of the other
              party, the First Party shall pay a referral fee to the party
              making the Referral Partner in accordance with the fee structure
              outlined in Exhibit A attached here to.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.2</span>
            <span>
              Payment Terms. Payment of referral fees shall be made for 3 years
              and the payouts shall be made in every subsequent Calendar Quarter
              plus 1 (One) month as per the manual that will be shared after
              acceptance of the terms and conditions.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.3</span>
            <span>
              The rates of referral fees are subject to revision by First Party
              from time to time and the Referral Partner shall be bound by the
              said revisions.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.4</span>
            <span>
              First Party may at its sole discretion decide not to pay such
              referral fee to the Referral Partner with respect to any
              client(s).
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.5</span>
            <span>
              The commission/fees payable to the Referral Partner will be
              governed by the norms specified by SEBI/ relevant regulator, if
              any, from time to time.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.6</span>
            <span>
              In the event any discrepancies / excess payment to Referral
              Partner is given on account of an error, then the Referral Partner
              shall reimburse such excessive amounts to First Party, failing
              which First Party shall be entitled to adjust the same from the
              referral fees to be paid by First Party to the Referral Partner in
              the subsequent fees to be paid.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>4.7</span>
            <span>
              All payments to be made out to Referral Partner under the terms of
              this Agreement shall be subject to the deduction of all applicable
              Taxes.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            5. Term and Termination
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.1</span>
            <span>
              Term. This Agreement shall commence on the Effective Date and
              shall continue in full force and effect until terminated by either
              party with written notice to the other party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.2</span>
            <span>
              Termination for Convenience. Either party may terminate this
              Agreement for convenience upon [Specify Notice Period, e.g., 30
              days] written notice to the other party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.3</span>
            <span>
              Termination for Cause. Either party may terminate this Agreement
              immediately if the other party breaches any material term or
              condition of this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.4</span>
            <span>
              In case of termination by First Party, any outstanding payment
              shall be forfeited by the Referral Partner.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 6px" }}>5.5</span>
            <span>
              In the event of a mutual termination of the agreement this
              Agreement shall continue till all outstanding payments of the
              Referral Partner are not cleared, however all obligations of the
              Referral Partner shall stand terminated on the day of termination
              of Agreement.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            6. Confidentiality
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 6px" }}>6.1</span>
            <span>
              The Receiving Party shall use the Confidential Information
              disclosed by the Disclosing Party solely for the purpose of its
              respective obligations under the Agreement. Except with the prior
              written consent of the Disclosing Party, the Receiving Party shall
              not disclose any Confidential Information of the Disclosing Party
              other than on a need-to-know basis to its own directors,
              employees, attorneys, accountants etc. The Confidential
              Information shall at all times remain the Disclosing Party’s
              property and shall not be copied or reproduced by the Receiving
              Party without prior written consent of the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.2</span>
            <span>
              The Receiving Party agrees and undertakes not to disclose either
              directly or indirectly, to any person(s) or entity, any
              Confidential Information of the Disclosing Party which is
              commercially sensitive or disclosure of which would adversely
              affect the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.3</span>
            <span>
              The Provision under this clause shall survive the termination of
              this Agreement.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>6.4</span>
            <span>
              The obligation of confidentiality contained in this clause shall
              not apply in the following circumstances:
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 12px" }}>(i)</span>
            <span>
              that which is or becomes generally available in the public domain
              other than by the Receiving Party’s breach of this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 10px" }}>(ii)</span>
            <span>
              that which was previously known, as established by records of the
              Receiving Party prior to receipt from the Disclosing Party and in
              possession of the Receiving Party prior to the Execution Date of
              this Agreement;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(iii)</span>
            <span>
              that which was lawfully obtained by the Receiving Party from a
              third party;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(iv)</span>
            <span>
              that which was developed independently by the Receiving Party
              without reference to the Confidential Information provided by the
              Disclosing Party;
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 8px" }}>(v)</span>
            <span>
              that which is disclosed or released in the public domain by the
              Receiving Party with the prior written approval of the Disclosing
              Party; or
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: " 0px 10px 0px 6px" }}>(vi)</span>
            <span>
              that which is required under Applicable Law or by any court or
              Governmental Authority to be disclosed, in which case the
              Receiving Party shall provide prompt notice of such request or
              requirement to the Disclosing Party.
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            7. Indemnification
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>7.1</span>
            <span></span> First Party hereby agrees, acknowledges and confirms
            that it has agreed to enter into this Agreement in reliance on the
            representations, warranties, undertakings and covenants made by the
            Referral Partner. The Referral Partner (“Indemnifying Paty”) hereby
            agrees to keep indemnified First Party, including its affiliates and
            their respective directors, officers, employees, agents and
            representatives (the indemnified party and each such Person being an
            “Indemnified Party”) from and against, any and all losses, claims,
            costs and expenses, penalties, Taxes, damages and liabilities,
            including Third Party Claims for damages, incurred on account of:
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 10px" }}>(i)</span>
            breach or non-performance by Referral Partner of any of its
            undertakings, warranties, covenants, declarations or obligations
            under this Agreement;
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            8. Dispute Resolution
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>8.1</span>
            <span>
              <Typography variant="body2">
                All or any disputes arising out of or in relation to the terms
                of this Agreement including the interpretation and validity of
                the terms thereof and the respective rights and obligations of
                the Parties shall be settled amicably by mutual discussions to
                the extent possible by prompt and good faith negotiation between
                Parties.
              </Typography>
              <Typography variant="body2" mt={1}>
                In the event Parties fail to reach an amicable settlement as per
                clause 8.1 above, the dispute shall be referred to a sole
                arbitrator mutually appointed by both Parties for adjudication
                as per the Arbitration and Conciliation Act, 1996 or any
                statutory amendments/modifications thereto for the time being in
                force. The award of the arbitrator shall be final and binding
                upon the Parties. The arbitration shall be held at Gurgoan and
                proceedings shall be conducted in English. The Parties shall
                bear their own expenses for the arbitration. All administrative
                costs of the arbitration, including fees of the mutually
                appointed arbitrator shall be equally borne by the Parties.
              </Typography>
              <Typography variant="body2" mt={1}>
                This Agreement shall be governed by and interpreted in
                accordance with laws of India and Parties hereto submit to the
                exclusive jurisdiction to the courts at New Delhi.
              </Typography>
            </span>
          </Typography>
          <Typography variant="h6" sx={styles.agreement_title}>
            9. Miscellaneous
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.1</span>
            <span>
              Entire Agreement. This Agreement constitutes the entire agreement
              between the parties and supersedes all prior oral or written
              agreements, understandings, or representations.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.2</span>
            <span>
              Governing Law. This Agreement shall be governed by and construed
              in accordance with the laws of India.
            </span>
          </Typography>
          <Typography variant="body2" sx={{ display: "flex" }}>
            <span style={{ padding: "0px 10px 0px 4px" }}>9.3</span>
            <span>
              Amendments. Any amendments to this Agreement must be made in
              writing.
            </span>
          </Typography>
        </Box>
      </Box> */}